import _classCallCheck from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/createClass.js";

/**
 * A class that behaves like a SignalRef but lazily generates the signal.
 * The provided generator function should use `Model.getSignalName` to use the correct signal name.
 */
export var SignalRefWrapper = /*#__PURE__*/function () {
  function SignalRefWrapper(exprGenerator) {
    _classCallCheck(this, SignalRefWrapper);

    Object.defineProperty(this, 'signal', {
      enumerable: true,
      get: exprGenerator
    });
  }

  _createClass(SignalRefWrapper, null, [{
    key: "fromName",
    value: function fromName(rename, signalName) {
      return new SignalRefWrapper(function () {
        return rename(signalName);
      });
    }
  }]);

  return SignalRefWrapper;
}();